import createCardListingView from '../Views/createCardListingView';
import FlexTalkCard from './FlexTalkCard';

export default createCardListingView(FlexTalkCard, {
  displayName: 'TalkListingView',
});
